

jQuery( document ).ready(function() {
  jQuery('.product_images').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: $('.product_images > .my-slide').length - 1,
  });
  
  
  
});

jQuery( document ).ready(function() {
jQuery('.click_to_scroll h3').click(function(){
  	$target = jQuery(this).attr("id");
// 	var headerheight = $( "#shopify-section-header" ).height();
  
  jQuery('html, body').animate({
    scrollTop: jQuery('.scroll_content #' + $target).position().top
  }, 400);
});    
  
  
//     if (jQuery(document).width() < 1580) {
//        scrollTop: jQuery('.scroll_content #' + $target).position().top - headerheight
//     }

  
});

// jQuery( document ).ready(function() {
//   console.log('new');
// 	jQuery('.custom-field__collection-refrence .custom-field--value .grid').slick({
//       infinite: true,
//       slidesToShow: 4,
//       slidesToScroll: 4,
//       centerPadding: '40px',
      
//       responsive: [
//         {
//           breakpoint: 1200,
//           settings: {
//             slidesToShow: 3,
//             slidesToScroll: 3
//           }
//         },
//         {
//           breakpoint: 769,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2
//           }
//         },
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1
//           }
//         }
//       ]
      
      
//     });
// });